import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footer1">
        <p className="copyright1">
          &copy; {new Date().getFullYear()}{" "}
          <a href="https://www.digipas.com" target="_blank">Digipas Technologies Inc.</a>
        </p>
      </div>
    );
  }
}
export default Footer;
